import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { isExternalUrl, stripDomainAndProtocalFromUrl } from "../../utilities/urlHelper";
// import Star from "../icons/starButton";

/**
 * StarButton component, extends the original Button with star effects
 * @param {*} buttonProps
 * @returns
 */
const StarButton = (buttonProps) => {
  const { className, href, text, target, title = null, wrapper = true } = buttonProps;

  const isExternal = isExternalUrl(href) ?? true;
  const [sanitisedHref, setSanitisedHref] = useState(href);

  useEffect(() => {
    if (!isExternal) {
      const cleanUrl = stripDomainAndProtocalFromUrl(href);
      setSanitisedHref(cleanUrl.startsWith("/") ? cleanUrl : "/" + cleanUrl);
    }
  }, [href, isExternal]);

  // const starElements = (
  //   <>
  //     <Star className="star-1" />
  //     <Star className="star-2" />
  //     <Star className="star-3" />
  //     <Star className="star-4" />
  //     <Star className="star-5" />
  //     <Star className="star-6" />
  //   </>
  // );

  const content = (() =>
    isExternal ? (
      <a
        href={sanitisedHref}
        className={className ? className + " btn-star" : "btn-donation btn-star"}
        title={title}
        target={target ?? "_blank"}
        rel="noopener noreferrer"
      >
        {text}
        {/* {starElements} */}
      </a>
    ) : (
      <Link to={sanitisedHref} className={className ? className + " btn-star" : "btn-donation btn-star"} title={title ?? text}>
        {text}
        {/* {starElements} */}
      </Link>
    ))();

  return wrapper ? <div className="button--container">{content}</div> : <>{content}</>;
};

export default StarButton;
